'use strict';

export default {
    user: {},
    users: null,
    filteredUsers: [],
    pendingUsers: [],
    selectedLawyerAndSupplierIds: []
};
